export default __webpack_public_path__ + "6e4807f772e7c3e327272efa13486d58.png";